import DynamicFieldsSerializer from '@linc-technologies/linced-common/serializers/dynamic-fields';

export default class PermissionReply extends DynamicFieldsSerializer {
  namespace = 'events';

  normalize(modelClass, payload) {
    let defaults = {
      intentionToAttend: false,
      pending: false,
    };
    Object.assign(defaults, payload);
    Object.assign(payload, defaults);
    return super.normalize(...arguments);
  }
}
